import Vue, { CreateElement, VueConstructor } from 'vue'
import Stack from './Stack.vue'
import { Component } from 'vue-property-decorator'

type V = any // VueConstructor

interface IDialog {
  component: V
  closable: boolean
  raiseOnClose: boolean
  props: any
  onClose: () => void
  resolve: (ev: any) => void
  reject: (ev: any) => void
}

export function makeEnv() {
  const closedByUser = {}
  const routeChanged = {}

  const vm = Vue.observable({
    stack: [] as IDialog[],
  })

  async function asyncAlert(o: {
    component: V,
    closable?: boolean,
    raiseOnClose?: boolean,
    props?: any,
  }) {
    return new Promise((resolve, reject) => {
      const { component, props } = o
      const closable = o.closable === undefined ? true : false
      const raiseOnClose = o.raiseOnClose === undefined ? false : true
      const d = {
        component,
        closable,
        raiseOnClose,
        props,
        resolve: (ev: any) => {
          close(d)
          resolve(ev)
        },
        reject: (ev: any) => {
          close(d)
          reject(ev)
        },
        onClose: () => {
          close(d);
          (raiseOnClose ? reject : resolve)(closedByUser)
        },
      }
      vm.stack.push(d)
    })
  }

  function close(d: IDialog) {
    vm.stack.splice(vm.stack.indexOf(d), 1)
  }

  @Component
  class AsyncAlertRoot extends Vue {
    render(h: CreateElement) {
      return h(Stack, {
        props: {
          stack: vm.stack,
        },
      })
    }
  }

  return { asyncAlert, AsyncAlertRoot, closedByUser }
}
